import { z } from 'zod';
import { ReceivableCurrency, ReceivableStatus, ReceivableStore } from '../utils';

export const receivableFormSchema = z.object({
  currency: z.nativeEnum(ReceivableCurrency, { required_error: 'Selecione a moeda' }),
  status: z.nativeEnum(ReceivableStatus, { required_error: 'Selecione o status' }),
  store: z.nativeEnum(ReceivableStore, { required_error: 'Selecione a loja' }),
  grossValue: z
    .number({ invalid_type_error: 'Informe um número' })
    .min(0, 'Valor não pode ser negativo'),
  relatedMonth: z
    .number({ required_error: 'Informe o mês de referência' })
    .int()
    .min(1, 'Mês inválido')
    .max(12, 'Mês inválido'),
  relatedYear: z
    .number({ required_error: 'Informe o ano de referência' })
    .int()
    .min(2000, 'Ano inválido')
    .max(2100, 'Ano inválido'),
  paidMonth: z
    .number()
    .int()
    .min(1, 'Mês inválido')
    .max(12, 'Mês inválido')
    .optional(),
  paidYear: z
    .number()
    .int()
    .min(2000, 'Ano inválido')
    .max(2100, 'Ano inválido')
    .optional(),
  receivableShareConfigId: z
    .string({ required_error: 'Selecione uma configuração de rateio' })
    .uuid('Selecione uma configuração válida'),
}).refine(
  (data) => {
    // Só valida se paidMonth e paidYear estiverem preenchidos
    if (!data.paidMonth || !data.paidYear) return true;
    
    // Valida se relatedMonth e relatedYear estão presentes
    if (!data.relatedMonth || !data.relatedYear) return true;
    
    try {
      // Compara apenas ano e mês (dia sempre 1)
      const relatedDate = new Date(data.relatedYear, data.relatedMonth - 1, 1);
      const paidDate = new Date(data.paidYear, data.paidMonth - 1, 1);
      return paidDate >= relatedDate;
    } catch {
      // Se houver erro ao criar a data, considera válido para não bloquear o form
      return true;
    }
  },
  {
    message: 'A data de recebimento não pode ser anterior à data de referência',
    path: ['paidMonth'],
  },
);

export type ReceivableFormValues = z.infer<typeof receivableFormSchema>;
